var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message waba-template-message" }, [
    _vm.getMetaText()
      ? _c("div", { staticClass: "meta-header" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
          _vm._v("\n        " + _vm._s(_vm.getMetaText()) + "\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.meta.headerText
      ? _c("div", { staticClass: "header-text" }, [
          _vm._v(_vm._s(_vm.meta.headerText)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [_vm._v(_vm._s(_vm.meta.body))]),
    _vm._v(" "),
    _vm.meta.buttons.length > 0
      ? _c(
          "div",
          { staticClass: "buttons" },
          _vm._l(_vm.meta.buttons, function (button, i) {
            return _c(
              "div",
              {
                key: button.id,
                staticClass: "single-button",
                class: { selected: false },
                on: { click: function ($event) {} },
              },
              [
                _c("div", {
                  staticClass: "single-button-text",
                  domProps: { innerHTML: _vm._s(button.text) },
                }),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.meta.footer
      ? _c("div", { staticClass: "footer" }, [_vm._v(_vm._s(_vm.meta.footer))])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }